import type { FaireProductEntity } from "../../entity_types/product";

export const p_3c5zw63rmu: FaireProductEntity = {
  token: "p_3c5zw63rmu",
  type: "product",
  name: "Retro Tides  Customizable Tee",
  brandToken: "b_1bd10jxt4j",
  brandName: "MT Brand Apparel",
  imageUrl: "https://cdn.faire.com/fastly/f5661159b7a3e72a54b127a946c6150d82540c59bc74cba49f36bf3146e64cea.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/deb463d950c3e9b6363e3acf9447dab0145be1842efaf92e0b618f213bb299f5.png",
    "https://cdn.faire.com/fastly/158c5cbecf41007987ccd31c28ab4f2dee3a4bead2394ce57e1061dbc218a27d.png"
  ],
  priceDollars: 13,
  description: "Our Retro Mountain design has been so well received we thought the coastal states may want to get in on the action.\nOur Retro Tide tee is customizable for your location. There are two areas to customize so please keep that in mind. The example shows \"SEASIDE\" and \"FLORIDA\".\nPlease add your customization in the space provided.\n\nThe colors of tees pictured are Heather Navy, Heather Red and Dusty Blue.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:51.434Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
